import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export default function Footer() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        jwtDecode(token); // Decode token to verify
        setIsLoggedIn(true);
      } catch (error) {
        console.error('Invalid token:', error);
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <footer className="footerSec">
      <div className="container">
        <div className="ftrlgotp">
          <Link to="/" className="foterlgoimg">
            {/* <img src="assets/images/foterlgo.png" alt="Logo" /> */}
            <img src={`${process.env.PUBLIC_URL}/assets/images/foterlgo.png`} alt="Logo" />
          </Link>
          <ul>
            <li>
              <a href="#url" target="_blank" rel="noopener noreferrer">
                <span className="icon-facebook-logo"></span>
              </a>
            </li>
            <li>
              <a href="#url" target="_blank" rel="noopener noreferrer">
                <span className="icon-instagram1"></span>
              </a>
            </li>
          </ul>
        </div>

        <div className="foterapp">
          <div className="container">
            <h3>Download APP</h3>
            <ul>
              <li>
                <a href="#url" target="_blank" rel="noopener noreferrer">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/appimge1.png`} alt="Apple App" />
                </a>
              </li>
              <li>
                <a href="#url" target="_blank" rel="noopener noreferrer">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/appimge2.png`} alt="Google Play" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="ftrtop">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="ftrinfo">
                <h3>Contact Us</h3>
                <ul>
                  <li>
                    <span className="icon-Vector26"></span>
                    <a href="mailto:help@jwlbook.com">help@jwlbook.com</a>
                  </li>
                  <li>
                    <span className="icon-Vector27"></span>
                    <a href="https://www.jwlbook.com" target="_blank" rel="noopener noreferrer">www.jwlbook.com</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="ftrlink active">
                <h3>About & Company</h3>
                <ul style={{ display: 'block' }}>
                  <li><Link to="/about-us">About Us</Link></li>
                  <li><Link to="/listing">Listing</Link></li>
                  {isLoggedIn ? (
                    <>
                      <li><Link to="/sell-product">Sell Your Jewelry</Link></li>
                      {/* <li><Link to="/listing">Your Jewelry</Link></li> */}
                    </>
                  ) : (
                    <>
                      <li><Link to="/login">Sell Your Jewelry</Link></li>
                      {/* <li><Link to="/login">Your Jewelry</Link></li> */}
                    </>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="ftrlink">
                <h3>Prices & Market Rates</h3>
                <ul>
                  <li><Link to="/price">Prices</Link></li>
                  {/* <li><Link to="/silver-price">Silver Prices</Link></li> */}
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="ftrlink">
                <h3>Customer Care</h3>
                <ul className="footerMenu">
                  {isLoggedIn ? (
                    <li><Link to="/dashboard">My Account</Link></li>
                  ) : (
                    <li><Link to="/login">My Account</Link></li>
                  )}
                  <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                  <li><Link to="/faq">FAQ’s</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="ftrbtm">
          <p>
            © Copyright 2026 <Link to="/">jwlbook.com</Link>. All Rights Reserved
          </p>
          <ul>
            <li>
              <a href="#url" target="_blank" rel="noopener noreferrer">
                <span className="icon-facebook-logo"></span>
              </a>
            </li>
            <li>
              <a href="#url" target="_blank" rel="noopener noreferrer">
                <span className="icon-instagram1"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
